import style from './infoCardStyle.module.css';
import playstore from '../../assets/images/Section-Footer-Button-Download-Playstore-Large.svg';
const InfoCardCompo = () => {
  return (
    <>
      <div className={`${style['rincian-5']} p-4 my-5`}>
        <h1>Butuh info lebih lanjut ??</h1>
        <a href="https://wa.me/+6281335258181" target="_blank" rel="noreferrer">
          <button
            type="button"
            className={`${style.tombolRincian5} btn btn-success mb-4 rounded-3 d-flex flex-row`}
          >
            <p className="m-0">Cari info lewat Whatsapp</p>
            <img
              src={require('../../assets/images/WA Solid.png')}
              alt=""
              className={style.icon}
            />
          </button>
        </a>

        <h1>Atau download aplikasi lewat</h1>
        <a href="https://play.google.com/store/apps/details?id=id.asc.sepakat">
          <img src={playstore} alt="" className={style.iconPS} />
        </a>
      </div>
    </>
  );
};

export default InfoCardCompo;
